module.exports = __webpack_public_path__ + "img/ico_arr_left.f88988f9.svg";